import col from './col.json';
import per from './per.json';
import ecu from './ecu.json';
import cri from './cri.json';
import gtm from './gtm.json';
import ven from './ven.json';

export const AVAILABLE_TRANSLATIONS = {
  COL: 'col',
  PER: 'per',
  ECU: 'ecu',
  CRC: 'cri',
  GTM: 'gtm',
  VEN: 'ven',
};

export const CURRENCIES = {
  COP: 'COP',
  PEN: 'PEN',
  USD: 'USD',
  CRC: 'CRC',
  GTQ: 'GTQ',
  VEF: 'VEF',
};

export const CURRENCIE2COUNTRY = {
  COP: 'COLOMBIA',
  PEN: 'PERU',
  USD: 'ECUADOR',
  CRC: 'COSTA RICA',
  GTQ: 'GUATEMALA',
  VEF: 'VENEZUELA'
};

export const CURRENCIE_2_COUNTRY_CODE = {
  COP: 343,
  PEN: 348,
  USD: 345,
  CRC: 314,
  GTQ: 347,
};

export default class Translation {

  static getTranslationFile(country: string) {

    switch (country) {
      case AVAILABLE_TRANSLATIONS.COL:
        return col;
      case AVAILABLE_TRANSLATIONS.PER:
        return per;
      case AVAILABLE_TRANSLATIONS.ECU:
        return ecu;
      case AVAILABLE_TRANSLATIONS.CRC:
        return cri;
      case AVAILABLE_TRANSLATIONS.GTM:
        return gtm;
      case AVAILABLE_TRANSLATIONS.VEN:
        return ven;
      default:
        return col;
    }
  }
}

